import 'global.css'

import { LANDING_BG_IMAGE } from 'constants/assets'

const NotFound = () => {
  return (
    <div
      className="bg-light-maroon flex min-h-screen flex-col items-center justify-center gap-5 bg-cover bg-center bg-no-repeat p-2.5 text-center"
      style={{ backgroundImage: `url(${LANDING_BG_IMAGE})` }}
    >
      <img src="/images/pocket_fm_big_logo.svg" alt="Pocket FM" />
      <h1 className="text-3xl font-bold text-slate-100">Page Not Found!!</h1>
    </div>
  )
}

export default NotFound
